module.exports = "https://cdn.realtymogul.com/static/media/icon_valadd.5fdf8296.svg";